{
  "name": "verfier",
  "description": "Verfier is a web based client application that uses verifiable healthcare API",
  "version": "5.32.0",
  "scripts": {
    "dev": "concurrently \"yarn run proxy\" \"vite dev --port 8080 --open\"",
    "build": "del-cli build && vite build && node ./post-build.js",
    "check": "svelte-check --tsconfig ./tsconfig.json",
    "check:watch": "svelte-check --tsconfig ./tsconfig.json --watch",
    "lint": "concurrently \"prettier --check .\" \"eslint .\"",
    "format": "prettier --write --plugin-search-dir=. .",
    "preview": "concurrently \"yarn run proxy\" \"vite preview --port 8080\"",
    "update-sentry": "node scripts/updatSentryPackage.cjs --",
    "proxy": "node scripts/proxyServer.cjs --"
  },
  "resolutions": {
    "ajv": "^6.14.0",
    "braces": "^3.0.3",
    "brace-expansion": "^2.0.3",
    "cookie": "^0.7.0",
    "cross-spawn": "^7.0.5",
    "devalue": "^5.6.4",
    "nanoid": "^3.3.8",
    "follow-redirects": "^1.16.0",
    "lodash": "^4.18.0",
    "micromatch": "^4.0.8",
    "minimist": "^1.2.6",
    "minimatch": "^9.0.7",
    "picomatch": "^2.3.2",
    "postcss": "^8.5.10",
    "rollup": "^4.59.0",
    "semver": "^7.5.2",
    "shell-quote": "^1.8.4",
    "tar": "^7.5.21",
    "undici": "^6.27.0",
    "uuid": "^11.1.1",
    "word-wrap": "^1.2.4",
    "esbuild": "^0.25.0",
    "js-yaml": "^4.2.0",
    "flatted": "^3.4.2",
    "yaml": "^1.10.3"
  },
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "@sveltejs/adapter-auto": "^7.0.1",
    "@sveltejs/kit": "^2.63.0",
    "@sveltejs/vite-plugin-svelte": "^7.1.2",
    "@types/node": "^22",
    "eslint": "^10.4.1",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-svelte": "^3.19.0",
    "globals": "^17.6.0",
    "prettier": "^3.8.3",
    "prettier-plugin-svelte": "^4.1.0",
    "svelte": "^5.56.1",
    "svelte-check": "^4.6.0",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.60.1",
    "vite": "^8.0.16",
    "@sveltejs/adapter-static": "3.0.2",
    "@types/d3": "^7.4.3",
    "@types/lodash": "^4.14.172",
    "@types/mime": "^3.0.1",
    "@types/ramda": "^0.30.1",
    "@types/string-format": "^2.0.1",
    "@types/ua-parser-js": "^0.7.39",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/eslint-plugin": "7.13.1",
    "@typescript-eslint/parser": "7.13.1",
    "concurrently": "^7.0.0",
    "cors-anywhere": "git+https://github.com/nodealpha/cors-anywhere.git",
    "del-cli": "^6.0.0",
    "follow-redirects": "^1.16.0",
    "fs-extra": "^10.0.0",
    "nanoid": "^3.3.8",
    "reflect-metadata": "^0.1.13",
    "svelte-preprocess": "^6.0.0",
    "tslib": "^2.3.1"
  },
  "type": "module",
  "husky": {
    "hooks": {
      "pre-commit": "npm run lint",
      "pre-push": "npm run lint"
    }
  },
  "engines": {
    "node": ">=20.10.0"
  },
  "dependencies": {
    "@sentry/browser": "^8.35.0",
    "@sentry/integrations": "7.73.0",
    "@svelte-plugins/datepicker": "^1.0.11",
    "chart.js": "^3.4.1",
    "crypto-hash": "^3.1.0",
    "d3": "^7.9.0",
    "dayjs": "^1.11.5",
    "deep-object-diff": "^1.1.9",
    "detect-browser": "^5.2.0",
    "dexie": "^4.0.11",
    "filesize": "^7.0.0",
    "js-convert-case": "^4.1.2",
    "jsondiffpatch-rc": "^0.4.2",
    "jszip": "^3.8.0",
    "loadjs": "^4.2.0",
    "lodash": "^4.18.0",
    "mime": "^3.0.0",
    "paginator": "^1.0.0",
    "pdfjs-dist": "^4.3.136",
    "pkce-challenge": "^5.0.0",
    "ramda": "^0.30.1",
    "ssn-validator": "^2.0.1",
    "string-format": "^2.0.0",
    "string-strip-html": "^9.1.0",
    "svelte-json-tree": "^0.1.0",
    "ua-parser-js": "^0.7.33",
    "uuid": "^11.1.1"
  }
}
